import { LinearProgress, Tooltip, Typography } from "@material-ui/core"
import styles from "./ReportsPage.module.scss"
import React, { FunctionComponent } from "react"

interface StorageProgressBarProps {
    maxStorage: number
    currentStorage: number
}

export const StorageProgressBar: FunctionComponent<StorageProgressBarProps> = ({
    maxStorage,
    currentStorage
}) => {
    function gbToMb(gbs: number) {
        return gbs * 1000
    }
    return (
        <Tooltip
            title={<Typography variant="caption">{`${gbToMb(currentStorage)} MB`}</Typography>}
            arrow
            placement="top"
        >
            <LinearProgress
                data-testid="storage-progress-bar"
                id="storage-progress-bar"
                variant="determinate"
                className={styles.ReportsPage__usage__bar}
                value={(currentStorage / maxStorage) * 100}
            />
        </Tooltip>
    )
}
